/* eslint-disable @typescript-eslint/no-require-imports */
require('smoothscroll-polyfill').polyfill()

import { Application } from "@hotwired/stimulus"

import "../styles/venues.scss"

import "../components/tabs"
import "../components/content/HideAndSeek"
import "../components/content/Scrollspy"
import "../components/content/StatusBar"
import { setupTabs } from "../components/tabs"
import { setupAccordions } from "../components/content/Accordion"
import { initVenueSearch } from "../components/elm_search"
import setupCarousel from "../components/venue/carousel"
import { setupVenueModals } from "../components/venue/modals"
import DisclosureItemController from "../controllers/disclosure_item_controller"
import ModalController from "../controllers/modal_controller"
import ModalTriggerController from "../controllers/modal_trigger_controller"
import RoomCarouselController from "../controllers/venue/room_carousel_controller"

// We use `Packages` here but note that `Elm` can be imported from any module
import { Elm } from "../components/elm/Venue/Packages.elm"
import setupPackages from "../components/venue/packages"
import setupReviews from "../components/venue/reviews"
import setupSpasNearby from "../components/venue/spas_nearby"
import { loadBackgroundImages }  from "../helpers/image_loader"

const setupStimulus = (): void => {
  const stimulusApp = Application.start()
  stimulusApp.register("disclosure-item", DisclosureItemController)
  stimulusApp.register("hero-modal", ModalController)
  stimulusApp.register("hero-modal-trigger", ModalTriggerController)
  stimulusApp.register("room-carousel", RoomCarouselController)
}

setupStimulus()
setupCarousel()
setupPackages(Elm.Venue)
setupVenueModals(Elm.Venue)
setupReviews(Elm.Venue)
setupSpasNearby(Elm.Venue)
loadBackgroundImages()
setupTabs()
setupAccordions()
initVenueSearch()
